import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'bi-report-manger-menu',
  templateUrl: './bi-report-manger-menu.component.html',
  styleUrls: ['./bi-report-manger-menu.component.scss']
})
export class BiReportMangerMenuComponent implements OnInit {
  @Input() reportMangerList: any;
  @Input() selectedItem!: string;
  @Input() items: any;
  @Input() collapsed!: boolean;
  @Input() isRight!: boolean;
  @Input() selectedMenuItem!: string[];
  activeButton: any;
  childExpandedPanels: { [key: string]: number } = {};

  constructor(@Inject('datasource') public _datasource: any, private translate: TranslateService ,
    private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, 
    private route: Router) {

  }

  ngOnInit(): void {


  }

  setActiveButton(buttonText: string): void {
    this.activeButton = buttonText;
  }

}
